import { Link } from "react-router-dom"
import PlayerInterface from "../../interfaces/Player.interface"

const PlayerTable: React.FC<{ players: PlayerInterface[] }> = ({ players }) => {
    return (
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                    <th scope="col" className="gap-2 px-6 py-3">
                        Jugador
                    </th>
                    <th scope="col" className="px-6 py-3">
                        País
                    </th>
                </tr>
            </thead>
            <tbody>
                {players.map(player => (
                    <tr key={player?.id as string} className="bg-white border-b">
                        <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                            <div className="flex items-center justify-center bg-gray-100 w-[40px] h-[40px] rounded-full text-zinc-700 font-bold">{player.name?.at(0)?.toLocaleUpperCase()}</div>
                            <Link to={`/p/${player.name}`}>{player?.name}</Link>
                        </td>
                        <td className="px-6 py-4">
                            {player?.country ?
                                <div className="flex items-center gap-2">
                                    <img className="bg-white" src={`https://flagsapi.com/${player?.country?.split(",")[0]}/flat/32.png`} alt="flag-country"></img>
                                    <p className="text-zinc-700">{player?.country?.split(",")[1]}</p>
                                </div>
                                : '-'}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default PlayerTable